<template>
	<vxe-modal v-model="modal" :loading="loading" title="月度指标设置" width="1200" height="600" @show="show" show-footer>
		<template #default>
			<vxe-toolbar>
				<template #buttons>
					<vxe-button status="primary" @click="add">新增</vxe-button>
				</template>
			</vxe-toolbar>
			<vxe-table keep-source ref="shopdataflowkpi" border show-overflow
				height="400" :data="tableData"
				:edit-config="{trigger: 'click', mode: 'cell', icon: 'vxe-icon-edit', showStatus: true}">
				<vxe-column field="shopname" title="店铺" :edit-render="{}">
					<template #default="{ row }">
						<span>{{ row.shopname }}</span>
					</template>
					<template #edit="{ row }">
						<el-select size="mini" v-model="row.shopname" transfer>
							<el-option v-for="item in shopnameList" :key="item.value" :value="item.value" :label="item.label"></el-option>
						</el-select>
					</template>
				</vxe-column>
				<vxe-column field="targetpayAmt" title="销售额目标" :edit-render="{}">
					<template #default="{ row }">
						<span>{{ row.targetpayAmt }}</span>
					</template>
					<template #edit="{ row }">
						<el-input-number size="mini" v-model="row.targetpayAmt" controls-position="right"
							:precision="2"></el-input-number>
					</template>
				</vxe-column>
				<vxe-column field="targetpayByrCnt" title="支付买家目标" :edit-render="{}">
					<template #default="{ row }">
						<span>{{ row.targetpayByrCnt }}</span>
					</template>
					<template #edit="{ row }">
						<el-input-number size="mini" v-model="row.targetpayByrCnt" controls-position="right"
							:precision="0"></el-input-number>
					</template>
				</vxe-column>
				<vxe-column field="targetcharge" title="总花费目标" :edit-render="{}">
					<template #default="{ row }">
						<span>{{ row.targetcharge }}</span>
					</template>
					<template #edit="{ row }">
						<el-input-number size="mini" v-model="row.targetcharge" controls-position="right"
							:precision="0"></el-input-number>
					</template>
				</vxe-column>
				<vxe-column field="targettime" title="指标时间" :edit-render="{}">
					<template #default="{ row }">
						<span>{{ fomatterTime(row.targettime) }}</span>
					</template>
					<template #edit="{ row }">
						<datePicker :sequence="false" v-model="row.targettime" />
					</template>
				</vxe-column>
				<vxe-column title="操作" width="60" show-overflow>
					<template #default="{ row }">
						<el-button size="mini" style="color: #F56C6C;" type="text" @click="del(row)">删除</el-button>
					</template>
				</vxe-column>
			</vxe-table>
		</template>
		<template #footer>
			<vxe-button status="success" content="保存" @click="save"></vxe-button>
		</template>
	</vxe-modal>
</template>
<style scoped>

</style>
<script>
	import datePicker from '@_system/components/formcomponents/common/datePicker/index.vue'
	export default {
		props: {
			data: {
				default: () => {
					return null
				}
			}
		},
		data() {
			return {
				modal: false,
				loading: false,
				tableData: [],
				shopnameList: []
			}
		},
		watch: {

		},
		computed: {
			device() {
				return window.systemMethods.device()
			}
		},
		created() {

		},
		mounted() {

		},
		methods: {
			init() {
				this.$api.BIshopflow.getTarget().then((res) => {
					this.tableData = res
				})
			},
			cancel() {
				this.modal = false
			},
			hide() {
				this.$emit('hide')
			},
			show() {
				this.tableData = []
				this.init()
			},
			modalShow() {
				this.modal = true
			},
			fomatterTime(time){
				if(time){
					return window.systemMethods.timestampToDate(time[0],true) +' 至 ' + window.systemMethods.timestampToDate(time[1],true)
				}
				return null
			},
			add() {
				this.$refs.shopdataflowkpi.insertAt()

			},
			del(row) {
				this.$refs.shopdataflowkpi.remove(row)
			},
			save(){
				this.loading = true
				let tabledata = this.$refs.shopdataflowkpi.getRecordset()
				this.$api.BIshopflow.setTarget(tabledata).then(() => {
					this.cancel()
					this.$message.success('操作成功')
					this.loading = false
				},()=>{
					this.loading = false
				})
			}
		},
		components: {
			datePicker
		}
	}
</script>